import React from 'react';

const AnnotationSvg = ({width = 20, height = 20, couleur = "white"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 43 40" fill="none">
        <g>
            <path id="Rectangle 319"
                  d="M17.7355 20.4415L34.5692 3.60775C34.5931 3.60067 34.6188 3.59336 34.6461 3.58595C34.8742 3.52418 35.2034 3.45983 35.5896 3.4545C36.3323 3.44426 37.3184 3.64579 38.2893 4.61667C39.2602 5.58755 39.4617 6.57371 39.4515 7.31634C39.4461 7.70259 39.3818 8.0318 39.32 8.25983C39.3126 8.28718 39.3053 8.31284 39.2982 8.33673L22.4645 25.1704L17.0907 25.8153L17.7355 20.4415Z"
                  stroke={couleur} strokeWidth="3"/>
            <path id="Vector 35" d="M30.4375 5.61914L36.9616 12.1432" stroke={couleur} strokeWidth="4"/>
            <path id="Vector 121"
                  d="M12.5504 28.4863C10.7969 28.4863 5.98377 27.8429 4.6237 29.2533C3.54672 30.3702 9.2205 32.0817 9.97453 32.4671C10.8007 32.8893 11.502 33.2849 11.6102 34.2589C11.7647 35.6493 10.1153 36.3562 9.02108 36.5932C7.28274 36.9699 5.47303 37.0338 3.71957 37.3494C3.25332 37.4333 2.45849 37.3975 2.22363 37.8672"
                  stroke={couleur} strokeWidth="3" strokeLinecap="round"/>
        </g>
    </svg>

);

export default AnnotationSvg;
